import { useMemo } from 'react'
import { CellProps, Column } from 'react-table'
import { useTranslation } from 'react-i18next'

import CircleRoundedIcon from '@mui/icons-material/CircleRounded'
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded'

import SelectionTable, { SelectionTableProps } from '@/components/ui/tables/SelectionTable'

export type EstablishmentData = {
  id: string
  name: string
  active: boolean
  admin: string
}

export type EstablishmentSelectionTableProps = Pick<SelectionTableProps<EstablishmentData>, 'data' | 'onSelect' | 'readOnly' | 'selected'>

export function EstablishmentSelectionTable(props: EstablishmentSelectionTableProps) {
  const { t } = useTranslation()

  const columns = useMemo(() => {
    return [
      {
        Header: t('page.createWaitingRoom.establishmentSelectionTable.header.name'),
        accessor: 'name',
        width: 'unset',
      },
      {
        Header: t('page.createWaitingRoom.establishmentSelectionTable.header.active'),
        accessor: 'active',
        Cell: ({ value }: CellProps<EstablishmentData, boolean>) => {
          return value ? <TaskAltRoundedIcon color="success" fontSize="small" /> : <CircleRoundedIcon color="error" fontSize="small" />
        },
        width: 'unset',
      },
      {
        Header: t('page.createWaitingRoom.establishmentSelectionTable.header.admin'),
        accessor: 'admin',
        width: 'unset',
      },
    ] as Column<EstablishmentData>[]
  }, [t])

  return <SelectionTable {...props} columns={columns} />
}

export default EstablishmentSelectionTable
